/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, lazy, useRef } from 'react';
import _forEach from 'lodash/forEach';
import _isEqual from 'lodash/isEqual';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { QuickView } from '@thd-olt-component-react/quick-view';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { MediaGalleryDesktop, MediaGalleryCarousel } from '@thd-olt-component-react/media-gallery';
import { Price } from '@thd-olt-component-react/price';
import { SalientPoints, SalientListItem } from '@thd-olt-component-react/salient-points';
import { ConsumerCardMessaging } from '@thd-olt-component-react/consumer-card-messaging';
import { Link, Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { ProductDetails } from '@thd-olt-component-react/product-details';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { StickyWithHeaderObserver } from '@thd-olt-component-react/sticky';
import {
  StyledConsumerCardMessagingDiv,
  Row,
  ProductSummaryContainer,
  PlaPriceWrapper,
  PriceDivWrapper,
  InfoWrapper,
  PlaPricePlaceholder,
} from './styles';

import { getFeatureGates } from '../../utils/featureGates';
import getThdStoreInfo from '../../utils/getThdStoreInfo';
import { QUERY_PARAM_SAMPLE_OMSID, Utils } from '../../utils/urlUtils';
import { getPlaConfiguredPrice } from '../../utils/plaConfigurationUtils';
import BuildAndBuy from '../subcomponents/BuildAndBuy';
import { HowItWorksAccordionSuspense } from './howItWorksAccordion/HowItWorksAccordionSuspense';
import { ColorsSuspense } from './Colors/ColorsSuspense';
import { DraftHeaderSuspense } from '../DraftHeaderSuspense';
import { RailFlyoutSuspense } from './RailFlyoutSuspense';
import { StickyHeaderSuspense } from './StickyHeaderSuspense/index';
import { ProductDetailsAccordionSuspense } from './ProductDetailsAccordionSuspense/index';
import SlabViewCallout from './SlabViewCallout/SlabViewCallout';
import dictionaryDefinitionApi from '../../api/dictionaryDefinitionApi';

const sampleOmsId = Utils.getParameterByName(QUERY_PARAM_SAMPLE_OMSID) || null;
const hasPlaGuid = Utils.hasPlaGuid();
const url = Utils.getEnvironment();

const documentSSR = typeof document !== 'undefined';

const Pip = (props) => {
  const {
    match,
    history,
    config,
    isProductAvailable,
    hideProductSpecifications,
    minimumPromoSqFt,
    isProductInfoAvailable,
    isStoreEnabled,
    storeNumber,
    currentSurface,
    getProductDetails,
    getSampleDetails,
    selectedColor,
    plaConfiguration,
  } = props;

  const ctx = useContext(ExperienceContext);
  const { channel } = ctx;
  const isMobile = channel === 'mobile';
  const [clientAvailable, setClientAvailable] = useState(null);
  const [price, setPrice] = useState(currentSurface.minPrice);
  const [expanded, setExpanded] = useState('');
  const [hasGallery, setHasGallery] = useState(false);
  const [quickView, setQuickView] = useState({ isOpen: false, itemId: null });
  const [slabDictionaryTerm, setSlabDictionaryTerm] = useState(null);
  const [hideSticky, setHideSticky] = useState(false);
  const [stickyNavChoice, setStickyNavChoice] = useState('');
  const [prevScrollY, setPrevScrollY] = useState(0);

  const atcRef = useRef(null);
  const { omsId } = match;
  const { pipSupportPhoneNumber } = config;

  const enableCecContactNumbers = getFeatureGates()?.enableCecContactNumbers;
  const isDraft = getFeatureGates()?.isDraft;

  const sqftText =
    documentSSR && document?.getElementsByClassName('sui-text-base sui-font-bold sui-ml-2');
  const stickyNavPrice =
    documentSSR &&
    document.getElementsByClassName(
      'sui-font-display sui-leading-none sui-px-[2px] sui-text-4xl sui--translate-y-[0.35rem]'
    );
  const mainPrice =
    documentSSR &&
    document?.getElementsByClassName(
      'sui-font-display sui-leading-none sui-px-[2px] sui-text-9xl sui--translate-y-[0.5rem]'
    );

  const { plaConfiguredPrice, plaConfigurationDetails } = plaConfiguration;
  const propProductData = {
    configuratorPricing: {
      itemId: omsId,
      pricing: {
        alternatePriceDisplay: false,
        conditionalPromotions: null,
        mapAboveOriginalPrice: null,
        message: null,
        original: 0,
        preferredPriceFlag: false,
        promotion: {
          dollarOff: 0,
          percentageOff: 0,
        },
        specialBuy: null,
        unitOfMeasure: selectedColor?.price || currentSurface?.minPrice ? 'sq. ft.' : null,
        value: selectedColor?.price || currentSurface?.minPrice,
      },
    },
  };

  const plaPropProductData = {
    configuratorPricing: {
      itemId: omsId,
      pricing: {
        alternatePriceDisplay: false,
        conditionalPromotions: null,
        mapAboveOriginalPrice: null,
        message: null,
        original: plaConfiguredPrice ? plaConfiguredPrice.AsConfigured : null,
        preferredPriceFlag: false,
        promotion: {
          dollarOff: plaConfiguredPrice
            ? plaConfiguredPrice.StrikeThroughPriceModel.PriceSavings
            : null,
          percentageOff: plaConfiguredPrice
            ? plaConfiguredPrice.StrikeThroughPriceModel.Percentage
            : null,
        },
        specialBuy: null,
        unitOfMeasure: null,
        value: plaConfiguredPrice ? getPlaConfiguredPrice(plaConfiguredPrice) : null,
      },
    },
  };

  const setCustomPrice = () => {
    if (stickyNavPrice && stickyNavPrice.length > 0) {
      const stickyNavPriceParent = stickyNavPrice[0].parentElement;
      const stickyNavAsteriskDiv = document.createElement('div');
      stickyNavAsteriskDiv.style.marginLeft = '0.25rem';
      stickyNavAsteriskDiv.style.marginTop = '-0.35rem';
      const stickNavAsterisk = document.createTextNode('*');

      stickyNavAsteriskDiv.appendChild(stickNavAsterisk);
      stickyNavAsteriskDiv.setAttribute('class', 'sui-font-display sui-text-3xl');

      const isStickyCustom = _includes(stickyNavPriceParent.classList, 'do-not-customize');
      if (!isStickyCustom) {
        stickyNavPriceParent.appendChild(stickyNavAsteriskDiv);
        stickyNavPriceParent.classList.add('do-not-customize');
      }
      if (sqftText && sqftText.length > 0) {
        sqftText[0].style.marginTop = '1.0rem';
        sqftText[0].style.marginLeft = '0.5rem';
        sqftText[0].style.fontSize = '0.8em';
      }
    }

    if (mainPrice && mainPrice.length > 0) {
      const mainPriceParent = mainPrice[0].parentElement;
      const asteriskDiv = document.createElement('div');
      asteriskDiv.style.marginLeft = '0.45rem';
      asteriskDiv.style.marginTop = '-0.5rem';
      const asterisk = document.createTextNode('*');

      asteriskDiv.appendChild(asterisk);
      asteriskDiv.setAttribute('class', 'sui-font-display sui-text-3xl');

      const isCustom = _includes(mainPriceParent.classList, 'do-not-customize');
      if (!isCustom) {
        mainPriceParent.appendChild(asteriskDiv);
        mainPriceParent.classList.add('do-not-customize');
      }
      if (sqftText && sqftText.length > 0) {
        sqftText[0].style.marginTop = '2.0rem';
        sqftText[0].style.marginLeft = '0.5rem';
        sqftText[0].style.fontSize = '1.2rem';
      }
    }
  };

  useEffect(() => {
    const id = config.productId;

    const dictionaryDefinitionApiUrl = `${config.eleanorBaseUrl}/${config.loadDictionaryDefinitionApi}`;
    const productLineId = config.productLineId;
    const surfaceTerm = `${config.partnerProductId}SlabDictionaryTerm`;
    dictionaryDefinitionApi(dictionaryDefinitionApiUrl, surfaceTerm, productLineId).then(
      (response) => {
        if (response.data && Object.keys(response.data).length > 0) {
          setSlabDictionaryTerm(response.data.definition);
        }
      }
    );

    getSampleDetails({
      id,
      storeId: storeNumber,
    });

    getProductDetails({
      omsId,
      storeNumber,
      pageType: 'PIP',
    });

    setClientAvailable(true);
  }, []);

  const pricingEvent = () => {
    if (!hasPlaGuid) {
      LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_pricing_event', propProductData);
    } else {
      LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_pricing_event', plaPropProductData);
    }
  };

  useEffect(() => {
    if (plaConfigurationDetails?.media && !hasGallery) {
      const parsedMedia = plaConfigurationDetails?.media?.images?.map((img, i) => {
        const imagePrimary = img.url.replace(/<size>/, '1000');
        const imageThumb = img.url.replace(/<size>/, '100');
        const urlParsed = img.url.replace(/\/<size>\//, /<SIZE>/);
        return {
          id: i + 1,
          key: i,
          primaryLink: imagePrimary,
          sizes: img.sizes,
          source: 'CONFIGURABLE_S3',
          thumbnail: imageThumb,
          type: 'IMAGE',
          url: urlParsed,
          videoStill: null,
        };
      });

      const galleryPayload = {
        configuredProductLabel: plaConfigurationDetails.title,
        externalMedia: [...parsedMedia],
      };
      setHasGallery(true);
      LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_media_gallery_event', galleryPayload);
    }
  }, [plaConfigurationDetails?.media]);

  const deteremineScroll = () => {

    const currentScrollY = window.pageYOffset;

    if (currentScrollY > prevScrollY && stickyNavChoice.length > 0) {
      setStickyNavChoice('');
    }
    setPrevScrollY(currentScrollY);

  };

  useEffect(() => {
    if (stickyNavChoice === '#how-it-works') {
      setHideSticky(true);
    } else { setHideSticky(false); }

  }, [stickyNavChoice]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return null;
    }
    window.addEventListener('scroll', deteremineScroll);

    return () => {
      window.removeEventListener('scroll', deteremineScroll);
    };

  }, [prevScrollY]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return null;
    }
    const displayStickyNav = () => {
      const shouldHide = window.pageYOffset > 850;
      if (shouldHide && propProductData.configuratorPricing.pricing.value !== 0) {
        pricingEvent();
        if (!hasPlaGuid) {
          setCustomPrice();
        }
      }
    };
    window.addEventListener('scroll', displayStickyNav, { passive: true });

    if (selectedColor?.price && !hasPlaGuid) {
      pricingEvent();
      setCustomPrice();
    }
    if (hasPlaGuid) {
      setCustomPrice();
      pricingEvent();
    }

    return () => {
      window.removeEventListener('scroll', displayStickyNav);
    };
  }, [currentSurface.minPrice, price, selectedColor, plaConfiguredPrice, mainPrice.length]);

  const specificationsRef = useRef(null);
  const questionsRef = useRef(null);
  const ratingsRef = useRef(null);
  const stickyNavRef = useRef(null);
  const productOverviewRef = useRef(null);
  const howItWorksRef = useRef(null);
  const colorsRef = useRef(null);
  const arRef = useRef(null);
  const handleARClick = () => {
    arRef.current.click();
  };

  const quickViewDiv = (
    <AddToCart
      itemId={quickView?.itemId}
      cartReqParams={{ quantity: 1, itemId: quickView?.itemId }}
    >
      Add Sample to Cart
    </AddToCart>
  );

  const handleAccordionChange = (accordion, canCloseAccordion = true) => {
    setStickyNavChoice(accordion);
    if (!expanded[accordion] || canCloseAccordion) {
      setExpanded((prevState) => ({ ...prevState, [accordion]: !prevState[accordion] }));
    }
  };

  const scrollTo = (offset, callback) => {
    const fixedOffset = offset.toFixed();
    const onScroll = () => {
      if (window.pageYOffset.toFixed() === fixedOffset) {
        window.removeEventListener('scroll', onScroll);
        callback();
      }
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    window.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  };

  const onClickQuickView = ({ itemId }) => {
    setQuickView({
      itemId,
      isOpen: true,
    });
  };

  const handleViewMoreDetails = (accordion, canCloseAccordion = true) => {
    if (!expanded[accordion] || canCloseAccordion) {
      setExpanded((prevState) => ({ ...prevState, [accordion]: !prevState[accordion] }));
    }

    const offset = productOverviewRef.current.offsetTop - 115;
    scrollTo(offset);
  };

  const handleProductDetailsClick = (accordion) => {
    handleAccordionChange(accordion, false);
  };

  return (
    <div className="sui-w-full 2xl:sui-container sui-mx-auto sui-my-0">
      {clientAvailable && enableCecContactNumbers && (
        <ErrorBoundary name="rail-flyout">
          <RailFlyoutSuspense contactNumber={pipSupportPhoneNumber} />
        </ErrorBoundary>
      )}
      {clientAvailable && isDraft && (
        <ErrorBoundary name="draft-header">
          <DraftHeaderSuspense />
        </ErrorBoundary>
      )}
      {clientAvailable && (
        <QueryProvider cacheKey="quick-view">
          <QuickView
            itemId={quickView?.itemId}
            isOpen={quickView?.isOpen}
            onClose={() => setQuickView({ itemId: null, isOpen: false })}
            footerElement={quickViewDiv}
          />
        </QueryProvider>
      )}
      <div className="sui-grid sui-grid-cols-12 sui-gap-x-5">
        {!hideSticky && (
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row">
            <div className="fusion-slot">
              <StickyHeaderSuspense
                channel={channel}
                handleAccordionChange={handleAccordionChange}
                omsId={omsId}
                stickyNavRef={stickyNavRef}
                ratingsRef={ratingsRef}
                colorsRef={colorsRef}
                howItWorksRef={howItWorksRef}
                productOverviewRef={productOverviewRef}
                specificationsRef={specificationsRef}
                questionsRef={questionsRef}
                hideSticky={hideSticky}
              />
            </div>
          </div>)}

        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-7">
          <div className="fusion-slot sui-bg-subtle sui-p-3 sui-mb-0">
            <QueryProvider cacheKey="breadcrumbs">
              <ErrorBoundary name="breadcrumbs">
                <div className="breadcrumbs sui-flex sui-flex-nowrap" style={{ height: 30 }}>
                  <Breadcrumbs itemId={omsId} useStencilDesign />
                </div>
              </ErrorBoundary>
            </QueryProvider>
          </div>
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-5" />
        </div>
        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row" />
        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-7">
          <div className={`${isMobile ? '' : 'sui-sticky sui-z-10'} sui-top-0`}>
            <QueryProvider cacheKey="product-details-media-gallery">
              <div className="fusion-slot sui-bg-primary sui-p-3 sui-mb-0 sui-relative">
                {!isMobile ? (
                  <>
                    <div className="product-details-placeholder">
                      <div className="badge-placeholder">
                        <ProductDetails.Badge itemId={omsId} />
                      </div>
                      <Row id="test-test">
                        <div>
                          <ErrorBoundary name="product-details">
                            <ProductDetails itemId={omsId}>
                              <div className="product-details__badge-title--wrapper">
                                <ProductDetails.BrandCollection showBrandHyperLink />
                                {plaConfigurationDetails && (
                                  // eslint-disable-next-line max-len
                                  <h1 className="sui-h4-bold sui-line-clamp-unset sui-text-primary">
                                    {plaConfigurationDetails.title}
                                  </h1>
                                )}
                                {!plaConfigurationDetails && <ProductDetails.Title />}
                              </div>
                              <ProductDetails.Ratings
                                showLoader
                                showBadge
                                target="#bazaar-voice-reviews"
                                offsetselector="#sticky-nav"
                                qaselector="#bazaar-voice-QA"
                                onClick={(event) => handleProductDetailsClick(event)}
                              />
                            </ProductDetails>
                          </ErrorBoundary>
                        </div>
                      </Row>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="product-details-placeholder">
                      <div className="badge-placeholder">
                        <ProductDetails.Badge itemId={omsId} />
                      </div>
                      <Row id="test-test">
                        <div>
                          <ErrorBoundary name="product-details">
                            <ProductDetails itemId={omsId}>
                              <div className="product-details__badge-title--wrapper">
                                <ProductDetails.BrandCollection showBrandHyperLink />
                                <ProductDetails.Title />
                              </div>
                              <ProductDetails.Ratings
                                showLoader
                                showBadge
                                target="#bazaar-voice-reviews"
                                offsetselector="#sticky-nav"
                                qaselector="#bazaar-voice-QA"
                                onClick={(event) => handleProductDetailsClick(event)}
                              />
                            </ProductDetails>
                          </ErrorBoundary>
                        </div>
                      </Row>
                    </div>
                  </>
                )}
              </div>
              <div className="fusion-slot sui-bg-primary sui-p-3 sui-mb-0">
                {!isMobile ? (
                  <>
                    <ErrorBoundary name="media-gallery-desktop">
                      <MediaGalleryDesktop
                        itemId={omsId}
                        media={plaConfigurationDetails?.media?.images}
                        showLoader
                        onMediaClick={handleARClick}
                        mainImageFetchPriority="high"
                      />
                    </ErrorBoundary>
                  </>
                ) : (
                  <>
                    <ErrorBoundary name="media-gallery-desktop">
                      <MediaGalleryCarousel
                        itemId={omsId}
                        overlayType="filmstrip"
                        showLoader
                        firstItemFetchPriority="high"
                      />
                    </ErrorBoundary>
                  </>
                )}
              </div>
            </QueryProvider>
          </div>
        </div>
        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-col-span-5">
          <div
            className={`fusion-slot sui-bg-primary sui-p-3 sui-mb-3 ${
              hasPlaGuid && plaConfiguredPrice ? '' : 'price-container'
            }`}
          >
            {clientAvailable && (
              <ErrorBoundary name="countertop-pricing">
                <div>
                  {hasPlaGuid && !plaConfiguredPrice && <PlaPricePlaceholder />}
                  {hasPlaGuid && plaConfiguredPrice && (
                    <PriceDivWrapper>
                      {plaConfiguredPrice?.StrikeThroughPriceModel?.HasStrikeThroughPricing && (
                        <div className="product-price-special-buy">
                          <img
                            height={52}
                            width={52}
                            alt="Special Buy"
                            // eslint-disable-next-line max-len
                            src="data:image/svg+xml;base64,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"
                          />
                        </div>
                      )}

                      <InfoWrapper>
                        <div>Covers {plaConfiguration.plaSquareFootage} square feet</div>
                        <PlaPriceWrapper className="price-format__large price-format__main-price">
                          {plaPropProductData?.configuratorPricing.pricing.original === 0 && (
                            <div className="price-format__large price-format__main-price">N/A</div>
                          )}
                          {plaPropProductData?.configuratorPricing.pricing.original > 0 && (
                            <QueryProvider cacheKey="countertop-pla-pricing">
                              <Price
                                itemId={omsId}
                                type="detailed"
                                channel="mobile"
                                skip
                                large
                                hideLimitPerOrder
                                displayEachUom={false}
                                clsRemediation={{
                                  placeholders: true,
                                  preservePlaceholders: true,
                                }}
                              />
                            </QueryProvider>
                          )}
                        </PlaPriceWrapper>
                      </InfoWrapper>
                    </PriceDivWrapper>
                  )}
                </div>
                {!hasPlaGuid && (
                  <div className="summary-price summary-background-alt">
                    <div
                      className="summary-price summary-background-alt"
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        padding: 20,
                        paddingBottom: 0,
                        marginBottom: 0,
                      }}
                    >
                      {selectedColor?.price &&
                        selectedColor?.price !== selectedColor?.originalPrice && (
                          <div className="product-price-special-buy" style={{ paddingRight: 10 }}>
                            <img
                              height={52}
                              width={52}
                              alt="Special Buy"
                              // eslint-disable-next-line max-len
                              src="data:image/svg+xml;base64,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"
                            />
                          </div>
                        )}
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div> Starting At</div>
                        <div
                          className="custom-price"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <ErrorBoundary name="eb-price-mobile-expanded">
                            <div style={{ display: 'flex', height: 76 }}>
                              <QueryProvider cacheKey="countertop-pricing">
                                <Price
                                  itemId={omsId}
                                  skip
                                  channel="mobile"
                                  large
                                  hideLimitPerOrder
                                  displayEachUom={false}
                                  clsRemediation={{
                                    placeholders: true,
                                    preservePlaceholders: true,
                                  }}
                                />
                              </QueryProvider>
                              {!selectedColor?.price && !currentSurface?.minPrice && (
                                <div
                                  style={{ position: 'absolute' }}
                                  className="price-format__large price-format__main-price"
                                >
                                  {!isProductAvailable && isProductAvailable !== null ? (
                                    <h1>N/A</h1>
                                  ) : (
                                    <Skeleton disablePadding>
                                      <SkeletonBlock aspect="wide" height={14} />
                                    </Skeleton>
                                  )}
                                </div>
                              )}
                            </div>
                          </ErrorBoundary>
                        </div>
                      </div>
                    </div>
                    <StyledConsumerCardMessagingDiv>
                      <QueryProvider cacheKey="countertop-consumercardmessaging">
                        <ConsumerCardMessaging itemId={omsId} showEverydayFinancing />
                      </QueryProvider>
                    </StyledConsumerCardMessagingDiv>
                  </div>
                )}
              </ErrorBoundary>
            )}
          </div>
          {slabDictionaryTerm && (
            <SlabViewCallout slabDictionaryTerm={slabDictionaryTerm.Definition} />
          )}
          {!isMobile && (
            <div className="summary-mobile fusion-slot sui-bg-primary sui-p-3 sui-mb-3">
              <QueryProvider cacheKey="countertop-salient-points">
                <ProductSummaryContainer
                  style={{ minHeight: 150 }}
                  className="summary-background-alt sui-p-10"
                >
                  <div className="zone-card">
                    <ErrorBoundary name="salient">
                      <SalientPoints itemId={omsId} max={3}>
                        <SalientListItem>
                          <Link
                            underline="always"
                            onClick={() => handleViewMoreDetails('#product-overview', false)}
                          >
                            View More Details
                          </Link>
                        </SalientListItem>
                      </SalientPoints>
                    </ErrorBoundary>
                  </div>
                </ProductSummaryContainer>
              </QueryProvider>
            </div>
          )}
          <div className="fusion-slot sui-bg-primary sui-p-3 sui-mb-3">
            <div style={{ minHeight: 120 }} className="summary-background-alt">
              <div>
                {clientAvailable && (
                  <BuildAndBuy
                    history={history}
                    omsId={omsId}
                    isProductAvailable={isProductAvailable}
                    minimumPromoSqFt={minimumPromoSqFt}
                    isStoreEnabled={isStoreEnabled}
                    contactNumber={pipSupportPhoneNumber}
                    config={config}
                    isProductInfoAvailable={isProductInfoAvailable}
                    atcRef={atcRef}
                    eventName="PIP"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="fusion-slot sui-bg-primary sui-p-3 sui-mb-3">
            <div style={{ minHeight: 50 }} className="summary-background-alt">
              {clientAvailable && (
                <button
                  type="button"
                  onClick={() => specificationsRef.current?.scrollIntoView({ behavior: 'smooth' })}
                >
                  <span
                    className="CompareSurfaceStyle sui-underline sui-text-primary sui-decoration-2 sui-underline-offset-8"
                    role="button"
                    tabIndex={0}
                    onClick={() => handleAccordionChange('#specifications', false)}
                  >
                    Compare Surface Materials
                  </span>
                </button>
              )}
            </div>
          </div>
          <div className="fusion-slot sui-bg-primary sui-p-3 sui-mb-3">
            <div
              id="how-it-works"
              style={{ minHeight: 330 }}
              className="summary-background-alt"
              ref={howItWorksRef}
            >
              {clientAvailable && <HowItWorksAccordionSuspense isMobile={isMobile} />}
            </div>
          </div>
        </div>
        {clientAvailable && isProductAvailable && isProductAvailable != null && (
          <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row">
            <div id="colors" ref={colorsRef} className="color-background">
              <div>
                <ErrorBoundary name="colors">
                  <ColorsSuspense
                    sampleOmsId={+sampleOmsId}
                    productId={omsId}
                    storeNumber={storeNumber || getThdStoreInfo().storeNumber}
                    isProductAvailable={isProductAvailable}
                    isProductInfoAvailable={isProductInfoAvailable}
                    history={history}
                    setPrice={setPrice}
                    quickViewRef={quickView}
                    stickyNavRef={stickyNavRef}
                    setQuickView={onClickQuickView}
                    selectedColor={selectedColor}
                    omsId={omsId}
                    minimumPromoSqFt={minimumPromoSqFt}
                    isStoreEnabled={isStoreEnabled}
                    contactNumber={pipSupportPhoneNumber}
                    config={config}
                    colorsRef={colorsRef}
                  />
                </ErrorBoundary>
              </div>
            </div>
          </div>
        )}
        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row">
          {clientAvailable && (
            <ProductDetailsAccordionSuspense
              isMobile={isMobile}
              expanded={expanded}
              handleAccordionChange={handleAccordionChange}
              omsId={omsId}
              pipSupportPhoneNumber={pipSupportPhoneNumber}
              hideProductSpecifications={hideProductSpecifications}
              productOverviewRef={productOverviewRef}
              specificationsRef={specificationsRef}
              questionsRef={questionsRef}
              ratingsRef={ratingsRef}
              url={url}
            />
          )}
        </div>
        <div className="sui-col-span-12 sui-flex sui-flex-col fusion-row lg:sui-hidden">
          {clientAvailable && atcRef?.current && (
            <StickyWithHeaderObserver
              boxShadow
              className="sui-bg-primary sui-p-3 sui-w-full"
              forwardRef={atcRef}
              offsetScroll={18}
              position="bottom"
              stickyByDefault
              stickyType="forwardRef"
              visibleByDefault
            >
              <div className="summary-background-alt">
                <BuildAndBuy
                  history={history}
                  omsId={omsId}
                  isProductAvailable={isProductAvailable}
                  minimumPromoSqFt={minimumPromoSqFt}
                  isStoreEnabled={isStoreEnabled}
                  contactNumber={pipSupportPhoneNumber}
                  config={config}
                  isProductInfoAvailable={isProductInfoAvailable}
                  sticky
                  eventName="Mobile : Sticky footer"
                />
              </div>
            </StickyWithHeaderObserver>
          )}
        </div>
      </div>
    </div>
  );
};

Pip.propTypes = {
  // actions
  getProductDetails: PropTypes.func.isRequired,
  getSampleDetails: PropTypes.func.isRequired,
  // properties
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired, // router
  // eslint-disable-next-line react/forbid-prop-types
  selectedColor: PropTypes.object,
  currentSurface: {
    surfureCode: PropTypes.number,
    skus: PropTypes.array,
    minPrice: PropTypes.number,
  },
  config: PropTypes.shape({
    enableCecContactNumbers: PropTypes.bool,
    productId: PropTypes.number.isRequired,
    eleanorBaseUrl: PropTypes.string.isRequired,
    loadDictionaryDefinitionApi: PropTypes.string.isRequired,
    partnerProductId: PropTypes.number.isRequired,
    productLineId: PropTypes.number.isRequired,
    theHomeDepotComputedUrl: PropTypes.string.isRequired,
    thdBazaarVoiceApiUrl: PropTypes.string.isRequired,
    thdBazaarVoiceApiKey: PropTypes.string.isRequired,
    thdBazaarVoiceUrl: PropTypes.string.isRequired,
    pipSupportPhoneNumber: PropTypes.string.isRequired,
    contactNumber: PropTypes.string.isRequired,
    // ...other configurations
  }).isRequired,
  isProductAvailable: PropTypes.bool,
  hideProductSpecifications: PropTypes.bool.isRequired,
  minimumPromoSqFt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isProductInfoAvailable: PropTypes.bool.isRequired,
  isStoreEnabled: PropTypes.bool.isRequired,
  storeNumber: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  plaConfiguration: PropTypes.object,
};

Pip.defaultProps = {
  isProductAvailable: null,
  selectedColor: null,
  currentSurface: {
    surfureCode: null,
    skus: [],
    minPrice: null,
  },
  plaConfiguration: null,
};

Pip.dataModel = extend(Price);

export default Pip;
